export default __webpack_public_path__ + "static/media/BirdsEyeViewLPA.c5b57a2a.png";